import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { STATUS } from 'domains/product-colour/constants'

const propTypes = {
  status: PropTypes.string
}

/**
 * @param {string} status
 */
const ProductColourStatusBadge = ({ status }) => {

  const colorMap = {
    [STATUS.DISABLED] : 'danger',
    [STATUS.ENABLED]  : 'success'

  }

  const color = colorMap[status] || 'default'

  return <StatusBadge color={ color } label={ status } />
}

ProductColourStatusBadge.propTypes = propTypes

export default ProductColourStatusBadge
